import { Component, Input, OnInit } from '@angular/core';
import { Patient } from 'src/app/core/entities/patient.entity';

import { caregiverRelationMapping } from 'src/app/core/enums/caregiver-relation';
import { educationLevelMapping } from 'src/app/core/enums/education-level';
import { professionalActivityMapping } from 'src/app/core/enums/professional-activity';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.css'],
})
export class InformationComponent implements OnInit {
  @Input() public patientProfile: Patient = new Patient();
  public submittedInfoForm: boolean = false;
  public educationLevelMapping = educationLevelMapping;
  public professionalActivityMapping = professionalActivityMapping;
  public caregiverRelationMapping = caregiverRelationMapping;

  constructor() {}

  ngOnInit(): void {}
}
